import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-faq-banner',
  standalone: true,
  imports: [CommonModule, ContainerComponent],
  template: '<div #sectionElement></div>',
  styles: []
})
export class FAQBannerComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sectionElement', { static: false }) sectionElement?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.sectionElement.nativeElement,
        'FAQ Banner',
        'faq-banner-section'
      );
    }
  }

  ngOnDestroy() {
    // Unregister section from analytics tracking
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.unregisterSectionFromTracking(this.sectionElement.nativeElement);
    }
  }
}
